// extracted by mini-css-extract-plugin
module.exports = {"container":"HowToUseDiagram_container__1TLrb","img":"HowToUseDiagram_img__3LOVv"};